import {IDatatypeResource} from "../../core/services/DatatypeService";
import * as _ from "lodash";
import * as moment from "moment";
import * as swal from "sweetalert";
export class DataManagementPageComponent implements ng.IComponentOptions {
  public controller: any = DataManagementController;
  public template: string = /*html*/`
    <h2>Dataset Management <span class="subtitle">- {{$ctrl.title[$ctrl.type]}}</span><button ng-show="$ctrl.type === 'datatype'" class="btn btn-primary pull-right" ng-click="$ctrl.addDatatype()">ADD NEW</button></h2>
      <div ng-show="$ctrl.type === 'datatype'">
      <div class="row padding-top">
        <div class="col-md-8">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Search" ng-model="searchText.datatype.$"/>
            <span class="input-group-btn">
              <button class="btn btn-default">
                <i class="fa fa-fw fa-search"></i>
              </button>
            </span>
          </div>
        </div>
        <div class="col-md-4">
          <ui-select ng-model="searchText.datatype.state" name="status" required>
            <ui-select-match placeholder="Choose State">
              <span ng-bind="$select.selected.name"></span>
            </ui-select-match>
            <ui-select-choices repeat="item.type as item in ($ctrl.states | filter: $select.search)">
              <span ng-bind="item.name"></span>
            </ui-select-choices>
          </ui-select>
        </div>
      </div>
      <table class="table table-striped table-hover" ng-init="searchText.datatype.state='!inactive'">
        <thead>
          <tr>
            <th><input type="checkbox" ng-model="$ctrl.selectedAll.datatype" ng-change="$ctrl.selectAllDatatype($ctrl.selectedAll.datatype)"/></th>
            <th>Name<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('datatype','display_name')"></i></th>
            <th>Code<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('datatype','code')"></i></th>
            <th>Ministry/Agency</th>
            <th>Category<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('datatype','category')"></i></th>
            <th>Frequency<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('datatype','frequency')"></i></th>
            <th>Status<i class="fa fa-fw fa-sort" ng-click="$ctrl.sortBy('datatype','state')"></i></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="datatype in $ctrl.datatypes | filter: searchText.datatype | orderBy: $ctrl.sortType.datatype: $ctrl.reverse.datatype">
            <td><input type="checkbox" ng-model="datatype.selected" /></td>
            <td>{{datatype.display_name}}</td>
            <td>{{datatype.code}}</td>
            <td>{{datatype.agency.display_name||datatype.ministry.display_name}}</td>
            <td>{{datatype.category}}</td>
            <td>{{$ctrl.frequencies[datatype.frequency]}}</td>
            <td>{{datatype.state}}</td>
            <td><i class="fa fa-fw fa-pencil btn-icon" uib-tooltip="Edit Dataset Type" ng-click="$ctrl.editDatatype(datatype)"></i></td>
          </tr>
        </tbody>
      </table>
      <div class="row padding-bottom">
        <div class="col-md-12">
          <button class="btn btn-default" type="button" ng-click="$ctrl.activateDatatype(true)">ACTIVATE</button>
          <button class="btn btn-default" type="button" ng-click="$ctrl.activateDatatype(false)">DEACTIVATE</button>
        </div>
      </div>
      </div>
      <div ng-show="$ctrl.type === 'submission'">
      <h4>
        <span class="label label-primary">Upcoming</span>
      </h4>
      <table class="table table-hover">
      <thead>
        <tr><th>No</th><th>Dataset</th><th>Agency/Ministry</th><th>Due Date</th><th>Upcoming(Days)</th><th></th><th></th></tr>
      </thead>
      <tbody>
        <tr ng-class="{'delayed': ($ctrl.getDiff(due.next_due) <0) }" ng-repeat="due in $ctrl.due"><td>{{$index + 1}}</td><td>{{due.datatype.display_name}}</td><td>{{due.group.value.display_name}}</td><td>{{due.next_due|date:'yyyy-MM-dd'}}</td><td class="day">{{$ctrl.getDiff(due.next_due)}}</td><td><button class="btn btn-default" type="button" ng-click="$ctrl.openReminder(due.datatype._id)">View Reminder Log</button></td><td><button class="btn btn-primary" ng-click="$ctrl.sendReminder(due.datatype._id)">Send Reminder</button></td></tr>
      </tbody>
      </table>
      <h4>
        <span class="label label-primary">Recently Updated</span>
      </h4>
      <table class="table table-hover table-striped">
      <thead>
        <tr><th>No</th><th>Dataset</th><th>Agency/Ministry</th><th>Due Date</th><th>Updated</th></tr>
      </thead>
      <tbody>
        <tr ng-repeat="latest in $ctrl.latest"><td>{{$index + 1}}</td><td>{{latest.datatype.display_name}}</td><td>{{latest.group.value.display_name}}</td><td>{{latest.next_due|date:'yyyy-MM-dd'}}</td><td>{{latest.updateOn|date:'yyyy-MM-dd'}}</td></tr>
      </tbody>
      </table>
      <div class="row">
        <div class="col-md-12 padding-bottom">
          <button class="btn btn-primary" type="button" ng-click="$ctrl.openFetcModal()">Manual Fetch Remote</button>
        </div>
      </div>
      </div>
    `;
}

export class DataManagementController {
  public static $inject: Array<string> = ["$scope", "DatatypeService", "$uibModal", "$stateParams", "$http"];
  public datatypes: Array<any>;
  public frequencies: any;
  public selectedAll: any;
  public type: string;
  public title: any;
  public latest:any;
  public due: any;
  public sortType: any;
  public reverse: any;
  public states: Array<any>;
  constructor(private $scope: ng.IScope, private DatatypeService: IDatatypeResource, private $uibModal: ng.ui.bootstrap.IModalService, private $stateParams: ng.ui.IStateParamsService, private $http: ng.IHttpService) {
    $scope.$emit("adminPageChange",{name:"data"});
    this.loadDatatype();
    this.frequencies = {
      o: "One Off",
      m: "Monthly",
      q: "Quarterly",
      a: "Annually",
      b: "Biannually"
    }
    this.sortType = {datatype: "createdOn"};
    this.reverse = {datatype: true};
    this.selectedAll = {datatype: false};
    this.type = $stateParams.type || 'datatype';
    this.title = {
      'datatype': "Dataset Type",
      'submission': "Data Submission Monitoring"
    }
    if (this.type === 'submission') {
      $http.get(`${BASE}/api/submission?offset=0&limit=10&sort=U`)
      .then((d:any) => {
        this.latest = d.data.result;
      })
      $http.get(`${BASE}/api/submission?offset=0&limit=10&sort=D`)
      .then((d:any) => {
        this.due = d.data.result;
      })
    }
    this.states = [
      {name: "Active", type: "!inactive"},
      {name: "Inactive", type: "inactive"},
      {name: "All Records", type: ""}
    ]
  }
  private loadDatatype() {
    this.datatypes = this.DatatypeService.query({allFields: true});
  }
  public addDatatype() {
    let modalInstance = this.$uibModal.open({
      component: "datatypeModal"
    })
    modalInstance.result.then((datatype) => {
      this.datatypes.push(datatype);
    });
  }
  public editDatatype(datatype) {
    let modalInstance = this.$uibModal.open({
      component: 'datatypeModal',
      resolve: {
        datatype: () => {
          return datatype;
        }
      }
    });
    modalInstance.result.then((datatype) => {
      this.loadDatatype();
    })
  }
  public selectAllDatatype(state) {
    _.each(this.datatypes, (_datatype) => {
      _datatype.selected = state;
    })
  }
  public activateDatatype(active: boolean) {
    let _datatypes = _.filter(this.datatypes, {selected: true});
    if (_datatypes.length) {
      let _names = _.reduce(_datatypes, (res, datatype) => {
        return res + "<strong>" +  datatype.display_name + "</strong><br/>";
      },"");
      swal({
        type: "info",
        title: active?"Activate Datatype":"Deactivate Datatype",
        html: true,
        text: `Are you sure you want to ${active?"activate":"deactivate"} the following datatype<br/>${_names}`,
        showCancelButton: true
      }, (isConfirm) => {
        if (isConfirm) {
          _.each(_datatypes, (_datatype) => {
            _datatype.state = active? "active": "inactive";
          })
          this.DatatypeService.updateAll(_datatypes)
        }
      })
    }
  }
  public sortBy(datatype:string, type: string) {
    this.sortType[datatype] = type;
    this.reverse[datatype] = !this.reverse[datatype];
  }
  public getDiff(date) {
    return moment(date).diff(moment(), 'days');
  }
  public sendReminder(datatype) {
    this.$http.post(`${BASE}/api/submission/reminder/${datatype}`, {})
    .then(d => {
      swal("Email Sent!", "Reminder Email has been sent to datatype users", "success");
    })
    .catch(err => {
      swal("Oops!", "We are currently unable to send reminder email, Please try again later", "warning");
    })
  }
  public openReminder(datatype) {
    let _modal = this.$uibModal.open({
      component: "reminderLogModal",
      resolve: {
        datatype: () => {
          return datatype;
        }
      }
    })
  }
  public openFetcModal() {
    let _modal = this.$uibModal.open({
      component: "manualFetchingModal",
      resolve: {
      }
    })
    _modal.result.then((res) => {
      const day = moment(res.date).diff(moment(), 'day')
      this.manualFetch(res.type, day)
    })
  }
  public manualFetch(type, days) {
    this.$http.post(`${BASE}/api/datatype/fetch`, {days, type})
    .then(d => {
      swal("Success!", "The Data has been successfully pulled", "success")
    })
    .catch(e => {
      swal("Oops", "Something went wrong. Please try again", "warning")
    })
  }
}
